import React from "react";
import Skeleton from "@mui/material/Skeleton";
import CheckoutAccordion from "../CheckoutAccordion/CheckoutAccordion";
import styles from "./CheckoutShimmer.module.scss";

export interface ICheckoutShimmer {
    height?: string;
}

const CheckoutShimmer = ({ height }: ICheckoutShimmer) => {
    return (
        <CheckoutAccordion
            className={styles.Wrapper}
            title={
                <div className={styles.HeaderWrapper}>
                    <Skeleton variant="circular" className={styles.Avatar} />
                    <Skeleton variant="rectangular" className={styles.Title} />
                </div>
            }
            defaultExpanded
            showExpandIcon={false}
            disabled
            classes={{
                root: styles.formGroupRoot,
                disabled: styles.formGroupDisabled,
            }}
            headerClasses={{
                root: styles.headerRoot,
                disabled: styles.formGroupDisabled,
                expanded: styles.formGroupExpanded,
            }}
        >
            <>
                {!height && (
                    <div className={styles.BodyWrapper}>
                        <Skeleton
                            variant="rectangular"
                            className={styles.Input}
                        />
                        <Skeleton
                            variant="rectangular"
                            className={styles.Input}
                        />
                        <Skeleton
                            variant="rectangular"
                            className={styles.Input}
                        />
                    </div>
                )}
                {height && (
                    <Skeleton
                        variant="rectangular"
                        className={styles.Input}
                        height={height}
                    />
                )}
            </>
        </CheckoutAccordion>
    );
};

CheckoutShimmer.defaultProps = {
    height: null,
};

export default CheckoutShimmer;
